import React, {useEffect, useState} from 'react'
import bg from '../../img/bg.png'
import axios from 'axios'
import logo from '../../img/logovhu.png'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default function MainPage() {
    const [data, setData] = useState([])
    const [mssv, setMssv] = useState('')

    const getData = async ()=>{
        if(mssv===''){
            alert('Vui lòng nhập MSSV của bạn.')
        }
        else {
            try {
                const res = await axios.get(`/api/thongtin?mssv=${mssv}`)
                setData(res.data)
                
            } catch (err) {
                alert(err.response.data.msg)
            }
        }
    }

    // console.log(typeof(data.ten))

  return (
    <div className='absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[100%] h-[100%] z-20 border-[5px] border-[#fff] bg-white text-center shadow-md rounded-md overflow-y-scroll py-[20px]'>
        <img src={logo} alt='Logo' className='w-[90px] h-auto mx-auto mb-[10px]'/>
        <p className='text-[28px] max-lg:text-[23px] text-center font-semibold'>THÔNG TIN LỊCH SINH HOẠT ĐẦU KHÓA</p>
        <input type='text' name='mssv' placeholder='Nhập mã số sinh viên....' value={mssv} onChange={(e)=>{setMssv(e.target.value)}}
            className='border-[1px] border-[#bbb] bg-white rounded-md shadow-md px-[20px] py-[10px] text-center w-[70%] mt-[25px] outline-none'/>
        <br/>
        <button className='bg-[#4ebe29] text-white font-bold px-[15px] py-[5px] rounded-sm mt-[20px] hover:bg-[#5bdb31] shadow-md'
            onClick={getData}>Xem</button>

        <TableContainer component={Paper} sx={{marginTop:'30px'}}>
            <Table sx={{ minWidth: 650, backgroundColor:'#fff' }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center" sx={{fontWeight:'bold'}}>Họ và tên</TableCell>
                        <TableCell align="center" sx={{fontWeight:'bold'}}>MSSV</TableCell>
                        <TableCell align="center" sx={{fontWeight:'bold'}}>Khoa</TableCell>
                        <TableCell align="center" sx={{fontWeight:'bold'}}>Ngành</TableCell>
                        <TableCell align="center" sx={{fontWeight:'bold'}}>Mã lớp</TableCell>
                        <TableCell align="center" sx={{fontWeight:'bold'}}>Lớp</TableCell>
                        <TableCell align="center" sx={{fontWeight:'bold'}}>Phòng</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell align="center">{data.ten?data.ten.toUpperCase():''}</TableCell>
                        <TableCell align="center">{data.mssv}</TableCell>
                        <TableCell align="center">{data.khoa}</TableCell>
                        <TableCell align="center">{data.nganh}</TableCell>
                        <TableCell align="center">{data.malopsv}</TableCell>
                        <TableCell align="center">{data.lop}</TableCell>
                        <TableCell align="center">{data.phong}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

        <div className=''>
            <p className='mt-[20px] font-bold text-red-600'>Lưu ý:</p>
            <p className='font-bold text-[18px] mb-[20px] mt-[10px]'>Nội dung</p>
            {
                data.noidung?data.noidung.map((n,i)=>(
                    <p key={i} className='bg-[#fafae1] my-[0px] py-[20px] px-[20px] text-justify border-[1px] border-[#fff]'><b>{i+1}.</b> &nbsp;&nbsp;{n}</p>
                ))
                :''
            }
        </div>
    </div>
  )
}

